module.exports = __webpack_public_path__ + "img/rubick.9a41b8b5.png";